import { stateToReset } from './state';

export const getCurrentPurchase = (state) => state.purchase;
export const decimalConfiguration = (state) => state.purchaseParams.decimalConfiguration;
export const productFiscalInformation = (state) => state.productOfPurchaseOnFiscalEdit.fiscal;
export const isEditing = (state) => state.purchase.isEditing;
export const isImportation = (state) => state.productOfPurchaseOnFiscalEdit.isImportation;
export const productOfPurchaseOnFiscalEdit = (state) => state.productOfPurchaseOnFiscalEdit;
export const productOfPurchaseCollection = (state) => state.products.productOfPurchaseCollection;
export const linkedDocumentCollection = (state) => state.linkedDocuments.linkedDocumentCollection;
export const paymentModeCollection = (state) => state.payments.paymentModeCollection;
export const totalPurchase = (state) => state.taxCalc.vNF;
export const transport = (state) => state.transport;
export const importedInvoiceFormData = (state) => state.importedInvoiceFormData;
export const importedInvoice = (state) => state.importedInvoice;
export const productOfPurchaseCollectionXmlImportation = (state) =>
  state.importedInvoice.products.productOfPurchaseCollection;
export const getDefaultAddressState = () =>
  stateToReset().purchase.supplierInformation.supplier.address;
export const getDefaultPhoneState = () =>
  stateToReset().purchase.supplierInformation.supplier.phone;
export const getDefaultProductOfPurchaseOnFiscalEditState = () =>
  stateToReset().productOfPurchaseOnFiscalEdit;
export const getDefaultTransportState = () => stateToReset().purchase.transport;
export const getDefaultNaturezaState = () => stateToReset().purchase.taxInformation.natureza;
export const getDefaultBuyerState = () => stateToReset().purchase.taxInformation.buyer;
export const getDefaultSupplierState = () => stateToReset().purchase.supplierInformation.supplier;
export const getDefaultNaturezaCfopState = () =>
  stateToReset().purchase.taxInformation.natureza.cfop;
